<template>
  <section v-if="theme === 'luxliebe'" class="merchant-information" :class="{ 'merchant-information--compact': compact }" :aria-label="$t('payment.merchant.heading')">
    <h2 v-if="!compact">{{ $t('payment.merchant.heading') }}</h2>
    <dl>
      <div><dt>{{ $t('payment.merchant.name') }}{{ compact ? ':' : '' }}</dt><dd>HALOSAURIDAE LTD</dd></div>
      <div><dt>{{ $t('payment.merchant.address') }}{{ compact ? ':' : '' }}</dt><dd>Riga Feraiou 7–9, Lizantia Court, Flat/Office 310, Agioi Omologites, 1087 Nicosia, Cyprus</dd></div>
      <div><dt>{{ $t('payment.merchant.country') }}{{ compact ? ':' : '' }}</dt><dd>{{ $t('payment.merchant.cyprus') }}</dd></div>
    </dl>
    <CardBrandLogos />
  </section>
</template>

<script>
import ThemeMixin from '@/mixins/ThemeMixin'
import CardBrandLogos from './CardBrandLogos.vue'
export default { name: 'MerchantInformation', mixins: [ThemeMixin], components: { CardBrandLogos }, props: { compact: { type: Boolean, default: false } } }
</script>

<style scoped>
.merchant-information { box-sizing: border-box; max-width: 680px; margin: 24px auto; padding: 20px; border: 1px solid #dedbd4; border-radius: 8px; background: #fff; color: #252525; font-size: 14px; line-height: 1.6; text-align: left; overflow-wrap: anywhere; }
.merchant-information h2 { margin: 0 0 12px; font-size: 16px; line-height: 1.4; }
.merchant-information dl, .merchant-information dd { margin: 0; }
.merchant-information dl > div + div { margin-top: 10px; }
.merchant-information dt { font-weight: 600; }
@media (max-width: 991px) { .merchant-information { margin: 20px; padding: 16px; } }
.merchant-information--compact { max-width: none; margin: 0; padding: 0; border: 0; border-radius: 0; background: transparent; color: inherit; font-size: 13px; line-height: 1.7; }
.merchant-information--compact dl > div + div { margin-top: 4px; }
.merchant-information--compact dt, .merchant-information--compact dd { display: inline; }
.merchant-information--compact dt { margin-right: 4px; }
.merchant-information--compact :deep(.card-brand-logos) { margin-top: 12px; gap: 8px; }
.merchant-information--compact :deep(.card-brand-logos li) { width: 96px; height: 52px; padding: 8px; }
.merchant-information--compact :deep(.card-brand-logos img) { width: 80px; height: 36px; }
</style>
